import {MessageType} from './message-type.enum';

export class Message {
  constructor(public lead: string, public text: string, public type: MessageType) {
  }
}
